import React, { Component } from 'react';
import { Jumbotron } from 'react-bootstrap';

class Banner extends Component {
  render() {
    return (
      <Jumbotron className={this.props.image}>
        <div className="container">
          <h1>{this.props.title}</h1>
        </div>
      </Jumbotron>
    )
  }
}

export default Banner;



// WEBPACK FOOTER //
// ./src/components/Banner.js